export enum JobLockStatus
{
    LOCKED = 'LOCKED',
    UNLOCKED = 'UNLOCKED',
    FORCEFULLY_UNLOCKED = 'FORCEFULLY_UNLOCKED'
}
